module.exports = __webpack_public_path__ + "img/mobile-warehouse.b534cd38.svg";